import { render, staticRenderFns } from "./package.vue?vue&type=template&id=bffa4bb8&scoped=true"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"
import style0 from "./package.vue?vue&type=style&index=0&id=bffa4bb8&prod&lang=css"
import style1 from "./package.vue?vue&type=style&index=1&id=bffa4bb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffa4bb8",
  null
  
)

export default component.exports